import { apiClient } from '~/api/client';

type SearchParams = {
  query: string;
  page: number;
  per_page: number;
  sort_field?: string;
  sort_order?: string;
  company_uuid?: number | string;
};

export const search = async (params: SearchParams) => apiClient.get('/support/users', { params });

type UpdateVerifiedCompaniesParams = {
  userId: string;
  verified_company_nmls_ids: string[];
};

export const updateVerifiedCompanies = async (params: UpdateVerifiedCompaniesParams) =>
  apiClient.patch(`/support/users/${params.userId}/verified_companies`, {
    verified_company_nmls_ids: params.verified_company_nmls_ids,
  });

type UpdateBalanceParams = {
  userId: string;
  credits: number;
};

type UpdateBalanceResponse = {
  credits: number;
};

export const updateBalance = async (params: UpdateBalanceParams) =>
  apiClient.patch<UpdateBalanceResponse>(`/support/users/${params.userId}/balance`, {
    balance: { credits: params.credits },
  });
